import React, { useEffect } from 'react';
import styles from "../../assets/css/error/popUpMessage.module.scss";
import { IoClose } from "react-icons/io5";
import { FaCheckCircle } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { popUpBoxTriggerOff } from '../../features/message/popUpSlice';
import { IoCloseCircleSharp } from "react-icons/io5";
import { IoIosWarning } from "react-icons/io";

const PopUpMessage = () => {
    const show = useSelector(state => state.popUpToggle.popUpToggle);
    const details = useSelector(state => state.popUpToggle.popUpDetails);
    const dispatch = useDispatch();

    useEffect(() => {
        if (show === true) {
            setTimeout(async () => {
                dispatch(popUpBoxTriggerOff());
            }, 7000);
        }
    }, [dispatch, show]);

    return (
        <div className={`${styles.popUp} ${show ? styles.on : ""} ${details.type === "error" && styles.error} ${details.type === "success" && styles.success} ${details.type === "info" && styles.info}`}>
            <div className={`${styles.check}`}>
                {details.type === "success" && <FaCheckCircle className={`${styles.success}`} />}
                {details.type === "error" && <IoCloseCircleSharp className={`${styles.error}`} />}
                {details.type === "info" && <IoIosWarning className={`${styles.info}`} />}
            </div>
            <div className={`${styles.message}`}>
                <h3>{details.heading}</h3>
                <p>{details.message}</p>
            </div>
            <div className={`${styles.close}`}>
                <IoClose onClick={() => dispatch(popUpBoxTriggerOff())} />
            </div>
            <div className={`${styles.line} ${details.type === "error" && styles.error} ${details.type === "success" && styles.success} ${details.type === "info" && styles.info}`}>
            </div>
        </div>
    )
}

export default PopUpMessage
